import Container from "../../../../components/container";
import { formatCurrency } from "../../../../utils";
import CharityIssueCharityViewModel from "../../../../viewModels/CharityIssueCharityViewModel";
import {
  UpdateCharityIssueCharity,
  DeleteCharityIssueCharity,
} from "./buttons";
import { Charity, CharityIssue } from "../../../../models";
import CharityIssueCharityCreateForm from "./charity-issue-charity-create-form";
import IconButton from "../../../../components/icon-button";
import { PencilIcon } from "@heroicons/react/24/outline";
import CharityIssueCharityEditForm from "./charity-issue-charity-edit-form";
import { useState } from "react";

export default function CharityIssueCharityTable({
  charityIssueCharities,
  charityIssues,
  charity,
}: {
  charityIssueCharities: CharityIssueCharityViewModel[];
  charityIssues: CharityIssue[];
  charity: Charity;
}) {
  const [editCharityIssueCharity, setEditCharityIssueCharity] =
    useState<CharityIssueCharityViewModel | null>(null);
  return (
    <Container className="max-w-3xl  text-left">        
      <table className="min-w-full text-gray-900 text-left ">
        <thead className="rounded-lg text-left text-sm font-normal">
          <tr>
            <th scope="col" className="px-6 py-3">
              Charity Issue
            </th>
            <th scope="col" className="px-6 py-3">
              Incidence
            </th>
          </tr>
        </thead>
        <tbody className="bg-white">
          {charityIssueCharities.map((charityIssueCharity) => (
            <tr
              key={charityIssueCharity.id}
              className="w-full text-left border-b py-3 text-sm last-of-type:border-none [&:first-child>td:first-child]:rounded-tl-lg [&:first-child>td:last-child]:rounded-tr-lg [&:last-child>td:first-child]:rounded-bl-lg [&:last-child>td:last-child]:rounded-br-lg"
            >
              {editCharityIssueCharity &&
              editCharityIssueCharity.id === charityIssueCharity.id ? (
                <td colSpan={3} className="whitespace-nowrap px-6 py-3 bg-gray-100">
                  <CharityIssueCharityEditForm
                    charity={charity}
                    charityIssues={charityIssues}
                    charityIssueCharity={editCharityIssueCharity}
                    onCancel={() => setEditCharityIssueCharity(null)}
                  />
                </td>
              ) : (
                <>
                  <td className="whitespace-nowrap px-6 py-3">
                    {charityIssueCharity.charityIssue?.name}
                  </td>
                  <td className="px-6 py-4">
                    {formatCurrency(charityIssueCharity.incidence || 0)}
                  </td>
                  <td className="px-6 py-4">
                    <div className="flex items-center justify-end gap-2">
                      <IconButton
                        label="Edit"
                        icon={PencilIcon}
                        onClick={() =>
                          setEditCharityIssueCharity(charityIssueCharity)
                        }
                      />
                      <DeleteCharityIssueCharity
                        charityIssueCharity={charityIssueCharity}
                      />
                    </div>
                  </td>
                </>
              )}
            </tr>
          ))}
        </tbody>
        <tfoot>
          <tr>
            <td colSpan={3} className="px-6 pl-3 py-4">
              <CharityIssueCharityCreateForm
                charity={charity}
                charityIssues={charityIssues}
              />
            </td>
          </tr>
        </tfoot>
      </table>
    </Container>
  );
}
